import styled from 'styled-components';
import { Table, Button, Form } from 'react-bootstrap';

export const TrackTableWrapper = styled.div`
  width: 100%;
  padding: 16px;
  gap: 16px;
  border: 1px solid var(--primary);
  border-radius: 4px;
  background: var(--white);
  display: flex;
  flex-direction: column;
`;

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const TrackTableStyled = styled(Table)`
  && {
    margin-bottom: 0;
    border: none;
    
    thead {
      background: var(--white);
      
      th {
        border: none;
        color: var(--primary);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        padding: 12px 16px;
        border-bottom: 1px solid var(--primary);
        background: var(--white);
        white-space: nowrap;
        
        &:last-child {
          text-align: right;
          padding-right: 16px;
        }
      }
    }
    
    tbody {
      tr {
        background: var(--white);
        border-bottom: 1px solid #e5e7eb;
        
        &:last-child {
          border-bottom: none;
        }
        
        td {
          border: none;
          color: var(--grey);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
          font-weight: 400;
          font-size: 16px;
          line-height: 140%;
          padding: 12px 16px;
          vertical-align: middle;
          
          &:last-child {
            text-align: right;
            padding-right: 16px;
          }
        }
      }
    }
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`;


export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  gap: 16px;
  
  .pagination-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const PaginationButton = styled(Button)`
  && {
    width: 32px;
    height: 32px;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    background: white;
    color: #374151;
    font-weight: 400;
    font-size: 14px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    
    &:hover:not(:disabled) {
      background: #f3f4f6;
      color: #374151;
      border-color: #d1d5db;
    }
    
    &:disabled {
      border-color: #d1d5db;
      color: #9ca3af;
      background: white;
      cursor: not-allowed;
    }
    
    &.active {
      background: #00599c;
      color: white;
      border-color: #00599c;
    }
    
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export const ItemsPerPageText = styled.span`
  color: #6b7280;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  
  &.em-andamento {
    background: #FFE7D1;
    color: #A95100;
  }
  
  &.concluído {
    background: #DCFFE0;
    color: #219D1D;
  }
  
  &.inscrito {
    background: #E0F2FE;
    color: #0369A1;
  }
  
  &.aguardando-resposta {
    background: #FFE7D1;
    color: #A95100;
  }
  
  &.respondida {
    background: #DCFFE0;
    color: #219D1D;
  }
`;
